<template>
  <div>
      <div class="category-container">
        <div class="title"> Projects </div>
        <div class="category active-category" style="margin-left: 25px; display: flex; justify-content: center;">
          <div class="heart"> </div>
          <span style="margin-left: 4px;"> Favorites </span>
        </div>
        <div class="category"> All </div>
      </div>
      
      <div class="content">
        <post-preview 
            to="/double_pendulum"
            title="The Double Pendulum Fractal"
            date="April 15th, 2021"
            desc="I explore a fractal-like structure by simultaneously simulating all possible double pendulums."
            preview="static/previews/pendulum_fractal.gif"/>
        
        <post-preview 
            to="/captcha"
            title="A Failed Attempt to Solve Captchas"
            date="March 22nd, 2021"
            desc="I built and trained a CNN to solve Captchas (almost worked)"/>

        <post-preview 
            to="/pokemon"
            title="Pokemon Name Generator"
            date="August 17th, 2020"
            desc="I used machine learning to generate new Pokemon names!"
            preview="static/previews/pokemon_gen.PNG"/>

        <post-preview 
            to="/mandelbrot"
            title="Mandelbrot Set Explorer"
            date="July 7th, 2020"
            desc="I created an explorable interactive Mandelbrot set"
            preview="static/previews/mandelbrot.png"/>
        
        <post-preview 
            to="/n_pendulum"
            title="N Pendulum"
            date="August 17th, 2019"
            desc="I simulate a chaotic N pendulum system"
            preview="static/previews/n_pendulum.gif"/>

        <post-preview 
            to="/infinite_polygons"
            title="Infinite Polygons"
            date="July 6th, 2019"
            desc="I explore an interesting geometric pattern and unsolved infinite product"/>

        <post-preview 
            to="/forces_simulator"
            title="Forces Simulator"
            date="May 2nd, 2019"
            desc="I created a way to simulate the path any projectile takes given its forces"/>

        <post-preview 
            to="/orbital_mechanics"
            title="Orbital Mechanics"
            date="December 15th, 2018"
            desc="I explore trajectories of the 2 body problem"/>

        <post-preview 
            to="/snake"
            title="Snake"
            date="June 29rd, 2018"
            desc="I did a speed run coding snake"/>

        <post-preview 
            to="/rotating_solids"
            title=" Rotating 3D Solids"
            date="June 3rd, 2018"
            desc="Here I create an animation of a rotating platonic solid using Javascript"/>
      </div>
  </div>
</template>

<script>
import PostPreview from "./PostPreview.vue";

export default {
  components: { PostPreview },
  name: 'Index',
  mounted: () => {
      do_js();
  }
}

function do_js() {
  let categories = document.querySelectorAll(".category");
  let content = document.querySelector(".content")

  // Favorites button
  const favorite_idx = new Set([0, 2, 3, 4]);
  categories[0].addEventListener("click", () => {
    if (!categories[0].classList.contains("active-category"))
      categories[0].classList.add("active-category")
    for (let i = 0; i < categories.length; i++) {
      if (i != 0 && categories[i].classList.contains("active-category"))
        categories[i].classList.remove("active-category")
    }

    for (let i = 0; i < content.children.length; i++) {
      if (favorite_idx.has(i))
        content.children[i].style['display'] = 'block';
      else
        content.children[i].style['display'] = 'none';
    }
  });
  categories[0].dispatchEvent(new Event("click"));

  // All button
  categories[1].addEventListener("click", () => {
    if (!categories[1].classList.contains("active-category"))
      categories[1].classList.add("active-category")
    for (let i = 0; i < categories.length; i++) {
      if (i != 1 && categories[i].classList.contains("active-category"))
        categories[i].classList.remove("active-category")
    }
    for (let i = 0; i < content.children.length; i++) {
      content.children[i].style['display'] = 'block';
    }
  });

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.category {
  border-radius: 20px;
  padding: 5px 9px 5px 9px;
  min-width: 50px;
  font-size: 12pt;
  margin: 0px 2px;
  border: 1px solid #545454;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}

.category:hover {
  background: #f2f2f2;
  border-color: #f2f2f2;
  color: black;
  cursor: pointer;
}

.active-category {
  background: #545454;
  color: white;
}

.category-container {
  display: flex;
  justify-content: left;
  padding: 0px;
  margin: 0px 0px;
}

.category:active {
  background: #fafafa;
}

.heart {
  position: relative;
  width: 10px;
  height: 10px;
  margin: auto 4px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: red;
}
.heart:before, .heart:after {
  position: absolute;
  width: 10px;
  height: 10px;
  content: '';
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -o-border-radius: 50%;
  border-radius: 50%;
  background-color: red;
}
.heart:before {
  bottom: 0px;
  left: -5px;
}
.heart:after {
  top: -5px;
  right: 0px;
}

.active-category .heart, .active-category .heart:before, .active-category .heart:after {
  background-color: white;
}

.category:hover .heart{
  background-color: red;
  animation: heart-beat;
  animation-duration: .5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.category:hover .heart:before {
  background-color: red;
  animation: heart-beat-before;
  animation-duration: .5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.category:hover .heart:after {
  background-color: red;
  animation: heart-beat-after;
  animation-duration: .5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes heart-beat {
  0%   {width: 10px; height: 10px;}
  50%  {width: 12px; height: 12px;}
  100% {width: 10px; height: 10px;}
}

@keyframes heart-beat-before {
  0%   {width: 10px; height: 10px; left: -5px;}
  50%  {width: 12px; height: 12px; left: -6px;}
  100% {width: 10px; height: 10px; left: -5px;}
}

@keyframes heart-beat-after {
  0%   {width: 10px; height: 10px; top: -5px;}
  50%  {width: 12px; height: 12px; top: -6px;}
  100% {width: 10px; height: 10px; top: -5px;}
}



</style>
